import React from 'react';
import { useWizard } from '../useWizard';
import OnboardingForm from '../forms/OnboardingForm';
import { WIZARD_STEPS } from '../../../types/wizard';

const OnboardingStep: React.FC = () => {
  const { state, stepErrors, updateOnboarding } = useWizard();
  const errors = stepErrors[WIZARD_STEPS.ONBOARDING] || {};

  return (
    <div className="wizard-step">
      <h2>Onboarding Information</h2>
      <p className="step-description">Provide additional onboarding details for this clinic.</p>

      <OnboardingForm
        values={state.onboarding}
        onChange={updateOnboarding}
        errors={errors}
      />
    </div>
  );
};

export default OnboardingStep;
